export * from './elastic.service';



// WEBPACK FOOTER //
// D:/Rohit's Project/Golfhubber/golfhubber_club_portal/src/app/services/elastic/index.ts